import { FieldValues } from 'react-hook-form'
import { FormTextFieldProps } from '../_types/formTextFieldProps.type'

// export const onlyNumbers = (value: string) => {
//   const isNegative = value.startsWith('-')
//   const digits = value.replace(/\D/g, '')
//   return isNegative ? '-' + digits : digits
// }

export const onlyNumbersInline = (value: string) => {
  return value.replace(/\D/g, '')
}

export const capitalizeFirstLetter = (text: string) => {
  if (!text) return ''
  return text[0].toUpperCase() + text.substring(1)
}

// export const formatWithSpaces = (value: string) => {
//   const isNegative = value.startsWith('-')
//   const valueWithoutMinus = isNegative ? value.substring(1) : value

//   const formatted = valueWithoutMinus.replace(/(\d{3})(?=\d)/g, '$1 ')
//   return isNegative ? '-' + formatted : formatted
// }

export const formatWithSpacesInline = (value: string) => {
  return value.replace(/(\d{3})(?=\d)/g, '$1 ') // This will insert a space after every 3 digits
}

// export const handleChange = <T extends FieldValues>(
//   e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
//   field: any,
//   props: FormTextFieldProps<T>
// ) => {
//   const newValue = e.target.value
//   const numericValue =
//     props.inputMode === 'tel' || props.inputMode === 'numeric'
//       ? onlyNumbers(newValue)
//       : newValue
//   let formatted = props.formatNumber
//     ? formatWithSpaces(numericValue)
//     : numericValue

//   if (
//     props.maxLength &&
//     formatted.replace(/\s/g, '').length > props.maxLength
//   ) {
//     formatted = formatted.slice(
//       0,
//       props.maxLength + Math.floor(props.maxLength / 3)
//     )
//   }

//   field.onChange(props.inputMode === 'numeric' ? formatted.trim() : formatted)
// }

export const handleChangeInline = <T extends FieldValues>(
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  field: any,
  props: FormTextFieldProps<T>
) => {
  const newValue = e.target.value
  const numericValue =
    props.inputMode === 'tel' || props.inputMode === 'numeric'
      ? onlyNumbersInline(newValue)
      : newValue
  let formatted = props.formatNumber
    ? formatWithSpacesInline(numericValue)
    : numericValue

  if (
    props.maxLength &&
    formatted.replace(/\s/g, '').length > props.maxLength
  ) {
    formatted = formatted.slice(
      0,
      props.maxLength + Math.floor(props.maxLength / 3)
    )
  }

  field.onChange(props.inputMode === 'numeric' ? formatted.trim() : formatted)
}
